// =====================================================
// CONFIGURAÇÃO - USA VARIÁVEIS DE AMBIENTE
// Arquivo: FillSign.App/src/lib/config.ts
// =====================================================

export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:5095',
  websiteUrl: import.meta.env.VITE_WEBSITE_URL || 'http://localhost:5173',
  appUrl: import.meta.env.VITE_APP_URL || 'http://localhost:5174',
  appName: import.meta.env.VITE_APP_NAME || 'FillSign',
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;

// Ambiente atual
export const ENVIRONMENT = config.environment;

// URL da API
export const API_BASE_URL = config.apiUrl;

// URL do Website (landing page)
export const WEBSITE_URL = config.websiteUrl;

// URL do App (este app)
export const APP_URL = config.appUrl;

// Helper function para construir URLs da API
export function getApiUrl(path: string): string {
  const baseUrl = config.apiUrl.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
}

// Helper function para construir URLs do Website
export function getWebsiteUrl(path: string): string {
  const baseUrl = config.websiteUrl.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
}

// Verificar se é ambiente de teste
export function isTestEnvironment(): boolean {
  const env = ENVIRONMENT.toLowerCase();
  return env === 'development' || env === 'dev' || env === 'staging' || env === 'uat';
}

// Nome do ambiente para display
export function getEnvironmentLabel(): string {
  const env = ENVIRONMENT.toLowerCase();
  switch (env) {
    case 'development':
    case 'dev':
      return 'DEV';
    case 'staging':
    case 'uat':
      return 'UAT';
    default:
      return 'PROD';
  }
}

// Debug: Log das configurações (apenas em dev)
if (config.isDevelopment) {
  console.log('[Config] Environment:', ENVIRONMENT);
  console.log('[Config] API_BASE_URL:', API_BASE_URL);
  console.log('[Config] APP_URL:', APP_URL);
  console.log('[Config] WEBSITE_URL:', WEBSITE_URL);
}

export default config;
